<template>
  <v-container fluid class="zp">

    <!-- plava traka -->
    <div class="zp-traka">
      <div>
        <div class="zp-naslov">Za povezati</div>
        <div class="zp-pod">
          poslovna godina {{ godina }} · uplate koje čekaju račun i računi koji čekaju uplatu
        </div>
      </div>
      <v-spacer></v-spacer>
      <button type="button" class="zp-b zp-b-bijeli" :disabled="ucitavam" @click="ucitaj">Osvježi</button>
      <button
        type="button"
        class="zp-b zp-b-stari"
        title="Otvara dosadašnji ekran zatvaranja stavaka"
        @click="otvoriStari(null)"
      >Stari način ▸</button>
    </div>

    <div v-if="greska" class="zp-greska" role="alert">{{ greska }}</div>
    <v-progress-linear v-if="ucitavam" indeterminate color="primary" class="mb-2"></v-progress-linear>

    <template v-if="ucitano">

      <!-- brojke -->
      <div class="zp-brojke">
        <div><span>Za povezati</span><b>{{ brojevi.zaPovezati }}</b></div>
        <div class="zp-ok"><span>Sigurnih</span><b>{{ brojevi.sigurnih }}</b></div>
        <div><span>Uplate: više mogućih</span><b>{{ brojevi.uplate.viseMoguce }}</b></div>
        <div><span>Uplate čekaju račun</span><b>{{ brojevi.uplate.cekaRacun }}</b></div>
        <div :class="{'zp-lose': brojevi.uplate.nemaPartnera > 0}">
          <span>Bez partnera</span><b>{{ brojevi.uplate.nemaPartnera }}</b>
        </div>
        <div><span>Računi čekaju uplatu</span><b>{{ brojevi.racuni.cekaUplatu }}</b></div>
      </div>

      <!-- alati -->
      <div class="zp-alati">
        <v-text-field
          v-model="trazi"
          label="Traži partnera, broj računa, opis, iznos…"
          outlined dense hide-details clearable
          prepend-inner-icon="mdi-magnify"
          class="zp-trazi"
          @input="traziOdgodjeno"
        ></v-text-field>
        <div class="zp-seg" role="group" aria-label="Konto">
          <button v-for="k in konta" :key="k.v" type="button"
            :class="{aktivan: konto === k.v}" @click="konto = k.v">{{ k.naziv }}</button>
        </div>
        <div class="zp-seg" role="group" aria-label="Sigurnost">
          <button v-for="f in filteri" :key="f.v" type="button"
            :class="{aktivan: filter === f.v}" @click="filter = f.v">
            {{ f.naziv }} <i>{{ brojZaFilter(f.v) }}</i>
          </button>
        </div>
        <label class="zp-kvacica">
          <input type="checkbox" v-model="prikaziBezPrijedloga"> računi bez prijedloga
        </label>
      </div>

      <!-- uplate koje cekaju racun -->
      <div class="zp-kartica">
        <div class="zp-glava">
          <h2>Uplate koje čekaju račun</h2>
          <small>
            {{ uplatePrikaz.length }} od {{ brojevi.uplate.ukupno }}
            · uplata često stigne prije računa, pa se veza radi naknadno
          </small>
          <span class="zp-razmak"></span>
          <button
            type="button"
            class="zp-b zp-b-zeleni"
            :disabled="sigurneVeze.length === 0 || povezujem"
            @click="poveziSigurne"
          >Poveži sve sigurne ({{ sigurneBroj }})</button>
        </div>

        <div v-if="uplatePrikaz.length === 0" class="zp-prazno">
          Nema uplata za odabrani filter.
        </div>

        <div v-for="r in uplatePrikazStranica" :key="'u' + r.uplata.id" class="zp-red" :class="{gotovo: gotovo['u' + r.uplata.id]}">
          <div class="zp-l">
            <div class="zp-partner">
              {{ r.uplata.partnerName || 'Bez partnera' }}
              <small v-if="r.uplata.partnerVATID">OIB {{ r.uplata.partnerVATID }}</small>
            </div>
            <div class="zp-opis">{{ r.uplata.Description }}</div>
            <div class="zp-datum">
              {{ oznakaUplate(r.uplata) }} · {{ datum(r.uplata.BookingDate) }} ·
              <b>{{ novac(r.uplata.otvoreno) }}</b>
              <span v-if="r.uplata.otvoreno < r.uplata.iznos - 0.005"> (od {{ novac(r.uplata.iznos) }})</span>
              · konto {{ r.uplata.konto }}
            </div>
          </div>

          <div class="zp-prijedlog">
            <template v-if="r.sigurnost === 'visoka'">
              <b>{{ oznakaRacuna(r.racuni[0]) }}</b> · otvoreno {{ novac(r.racuni[0].otvoreno) }}
              <span class="zp-datum">· {{ datum(r.racuni[0].InvoiceDate || r.racuni[0].BookingDate) }}</span>
              <small><span class="zp-oznaka visoka">visoka</span>{{ r.razlogTekst }}</small>
            </template>

            <template v-else-if="r.sigurnost === 'vise_moguce'">
              <template v-if="r.razlog === 'zbroj_racuna'">
                <b>{{ r.racuni.length }} računa</b> zbrojeno {{ novac(r.iznos) }}:
                <span v-for="x in r.racuni" :key="x.id" class="zp-zeton">{{ oznakaRacuna(x) }} · {{ novac(x.otvoreno) }}</span>
              </template>
              <template v-else>
                {{ r.kandidati.length }} {{ r.kandidati.length === 1 ? 'račun' : 'računa' }} za izbor
                <select class="zp-izbor" :value="izborId(r)" @change="postaviIzbor(r, $event.target.value)">
                  <option v-for="x in r.kandidati" :key="x.id" :value="x.id">
                    {{ oznakaRacuna(x) }} · {{ datum(x.InvoiceDate || x.BookingDate) }} · {{ novac(x.otvoreno) }}
                  </option>
                </select>
              </template>
              <small><span class="zp-oznaka zuta">više mogućih</span>{{ r.razlogTekst }}</small>
            </template>

            <template v-else-if="r.sigurnost === 'ceka_racun'">
              Račun još nije unesen
              <small><span class="zp-oznaka crvena">čeka račun</span>povezat će se čim račun stigne (nudi se automatski)</small>
            </template>

            <template v-else>
              <template v-if="r.partnerPrijedlog">
                Možda: <b>{{ r.partnerPrijedlog.partnerName || r.partnerPrijedlog.partnerVATID }}</b>
                <small>
                  <span class="zp-oznaka" :class="r.partnerPrijedlog.sigurnost === 'visoka' ? 'visoka' : 'zuta'">
                    {{ r.partnerPrijedlog.sigurnost }}
                  </span>
                  prepoznat po {{ izvorPartnera(r.partnerPrijedlog.izvor) }}
                  <span v-if="r.partnerPrijedlog.kandidati.length > 1"> ({{ r.partnerPrijedlog.kandidati.length }} kandidata)</span>
                </small>
              </template>
              <template v-else>
                Partner nije prepoznat
                <small><span class="zp-oznaka zuta">nema partnera</span>u opisu nema OIB-a ni IBAN-a koji bi odredio partnera</small>
              </template>
            </template>
          </div>

          <div class="zp-radnja">
            <template v-if="gotovo['u' + r.uplata.id]"><span class="zp-gotovo">povezano ✓</span></template>
            <template v-else>
              <button v-if="r.sigurnost === 'visoka'" type="button" class="zp-b zp-b-zeleni"
                :disabled="povezujem" @click="poveziRedakUplate(r)">Poveži</button>
              <button v-else-if="r.sigurnost === 'vise_moguce'" type="button" class="zp-b zp-b-obrub"
                :disabled="povezujem" @click="poveziRedakUplate(r)">Poveži</button>
              <template v-else-if="r.sigurnost === 'nema_partnera'">
                <button v-if="r.partnerPrijedlog" type="button" class="zp-b zp-b-obrub"
                  :disabled="povezujem" @click="dodijeli(r, r.partnerPrijedlog)">Dodijeli ovog</button>
                <button type="button" class="zp-b zp-b-obrub" @click="otvoriDijalog(r)">Dodijeli partnera</button>
              </template>
              <button v-if="r.sigurnost !== 'nema_partnera'" type="button" class="zp-b zp-b-sivi"
                @click="otvoriStari(r.uplata)">Odaberi ručno</button>
            </template>
          </div>
        </div>

        <div v-if="uplatePrikaz.length > uplatePrikazStranica.length" class="zp-jos">
          <button type="button" class="zp-b zp-b-obrub" @click="stranicaU += 1">
            Prikaži još ({{ uplatePrikaz.length - uplatePrikazStranica.length }})
          </button>
        </div>

        <!-- racuni koji cekaju uplatu -->
        <div class="zp-podnaslov">
          Računi koji čekaju uplatu
          <span>({{ racuniPrikaz.length }} od {{ brojevi.racuni.ukupno }}
            · {{ brojevi.racuni.sPrijedlogom }} s prijedlogom uplate;
            {{ brojevi.racuni.vecUGornjemPopisu }} računa već stoji kao prijedlog u popisu iznad)</span>
        </div>

        <div v-if="racuniPrikaz.length === 0" class="zp-prazno">
          Nema računa za odabrani filter.
        </div>

        <div v-for="r in racuniPrikazStranica" :key="'r' + r.racun.id" class="zp-red" :class="{gotovo: gotovo['r' + r.racun.id]}">
          <div class="zp-l">
            <div class="zp-partner">
              {{ oznakaRacuna(r.racun) }} · {{ r.racun.partnerName }}
              <small>OIB {{ r.racun.partnerVATID }}</small>
            </div>
            <div class="zp-datum">
              izdan {{ datum(r.racun.InvoiceDate || r.racun.BookingDate) }}
              <span v-if="r.racun.InvoicePaymentDeadlineDate"> · dospijeće {{ datum(r.racun.InvoicePaymentDeadlineDate) }}</span>
              · otvoreno <b>{{ novac(r.racun.otvoreno) }}</b> · konto {{ r.racun.konto }}
            </div>
          </div>

          <div class="zp-prijedlog">
            <template v-if="r.sigurnost === 'ceka_uplatu'">
              Uplata još nije stigla
              <small><span class="zp-oznaka crvena">čeka uplatu</span>{{ r.razlogTekst }}</small>
            </template>
            <template v-else-if="r.razlog === 'zbroj_uplata'">
              <b>{{ r.uplate.length }} uplata</b> zbrojeno {{ novac(r.iznos) }}:
              <span v-for="u in r.uplate" :key="u.id" class="zp-zeton">{{ oznakaUplate(u) }} · {{ novac(u.otvoreno) }}</span>
              <small><span class="zp-oznaka zuta">više mogućih</span>{{ r.razlogTekst }}</small>
            </template>
            <template v-else>
              Uplata <b>{{ novac(r.uplate[0].otvoreno) }}</b> od {{ datum(r.uplate[0].BookingDate) }}
              ({{ oznakaUplate(r.uplate[0]) }})
              <small><span class="zp-oznaka visoka">visoka</span>{{ r.razlogTekst }}</small>
            </template>
          </div>

          <div class="zp-radnja">
            <template v-if="gotovo['r' + r.racun.id]"><span class="zp-gotovo">povezano ✓</span></template>
            <template v-else>
              <button v-if="r.sigurnost !== 'ceka_uplatu'" type="button"
                class="zp-b" :class="r.sigurnost === 'visoka' ? 'zp-b-zeleni' : 'zp-b-obrub'"
                :disabled="povezujem" @click="poveziRedakRacuna(r)">Poveži</button>
              <button type="button" class="zp-b zp-b-sivi" @click="otvoriStari(r.racun)">Odaberi ručno</button>
            </template>
          </div>
        </div>

        <div v-if="racuniPrikaz.length > racuniPrikazStranica.length" class="zp-jos">
          <button type="button" class="zp-b zp-b-obrub" @click="stranicaR += 1">
            Prikaži još ({{ racuniPrikaz.length - racuniPrikazStranica.length }})
          </button>
        </div>
      </div>
    </template>

    <!-- dodjela partnera -->
    <v-dialog v-model="dijalog" max-width="560">
      <v-card v-if="dijalogRed">
        <v-card-title class="zp-dijalog-naslov">Dodijeli partnera</v-card-title>
        <v-card-text class="pt-4">
          <div class="zp-opis mb-3">
            {{ dijalogRed.uplata.Description }} · {{ datum(dijalogRed.uplata.BookingDate) }} ·
            <b>{{ novac(dijalogRed.uplata.otvoreno) }}</b>
          </div>
          <v-autocomplete
            v-model="odabraniPartner"
            :items="partnerStavke"
            item-text="tekst"
            item-value="partnerVATID"
            label="Traži partnera po nazivu ili OIB-u"
            outlined dense hide-details clearable
            no-data-text="Partner nije pronađen u šifrarniku"
          ></v-autocomplete>
          <div v-if="dijalogRed.partnerPrijedlog && dijalogRed.partnerPrijedlog.kandidati.length > 1" class="mt-3">
            <span class="zp-datum">Kandidati iz opisa:</span>
            <span v-for="k in dijalogRed.partnerPrijedlog.kandidati" :key="k.partnerVATID"
              class="zp-zeton zp-klik" @click="odabraniPartner = k.partnerVATID">{{ k.partnerName }}</span>
          </div>
          <div class="zp-datum mt-3">
            Partner se upisuje na redak uplate u glavnoj knjizi. Nakon toga uplata dobiva prijedlog računa.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dijalog = false">Odustani</v-btn>
          <v-btn color="primary" :disabled="!odabraniPartner || povezujem" :loading="povezujem" @click="potvrdiDijalog">
            Dodijeli
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" bottom :timeout="5000" :color="snackColor">{{ snackTekst }}</v-snackbar>
  </v-container>
</template>

<script>
// Za povezati - jedan popis svih uplata koje cekaju racun i svih racuna koji
// cekaju uplatu, s prijedlogom veze uz svaki redak i potvrdom jednim klikom.
//
// Razlog: uplata cesto stigne prije racuna, pa se veza radi naknadno, a ne
// zelimo se stalno vracati na izvode. Prijedloge i njihovu sigurnost racuna
// server (GET /zatvaranja/zapovezati, helpers/zaPovezati.js). Veza se upisuje
// postojecim POST /zatvaranja/povezi, koji sam provjerava otvoreni iznos, partnera
// i poslovnu godinu - pa dvostruki klik ne moze zatvoriti dokument dvaput.

import MainLedgerZatvaranjeService from '@/services/MainLedgerZatvaranjeService'
import dateFormat from '@/snippets/dateFormat'

const n2 = (v) => Math.round((parseFloat(v) || 0) * 100) / 100
const KORAK = 50

export default {
  name: 'MainLedgerZaPovezati',
  data () {
    return {
      ucitavam: false,
      ucitano: false,
      povezujem: false,
      greska: '',
      uplate: [],
      racuni: [],
      brojevi: {
        uplate: {ukupno: 0, visoka: 0, viseMoguce: 0, cekaRacun: 0, nemaPartnera: 0},
        racuni: {ukupno: 0, sPrijedlogom: 0, cekaUplatu: 0, vecUGornjemPopisu: 0},
        sigurnih: 0,
        zaPovezati: 0
      },
      trazi: '',
      odgoda: null,
      konto: 'sve',
      konta: [
        {v: 'sve', naziv: 'Sva konta'},
        {v: '1200', naziv: 'Kupci 1200'},
        {v: '2200', naziv: 'Dobavljači 2200'}
      ],
      filter: 'sve',
      filteri: [
        {v: 'sve', naziv: 'Sve'},
        {v: 'visoka', naziv: 'Sigurno'},
        {v: 'vise_moguce', naziv: 'Više mogućih'},
        {v: 'ceka_racun', naziv: 'Čeka račun'},
        {v: 'nema_partnera', naziv: 'Bez partnera'}
      ],
      prikaziBezPrijedloga: false,
      stranicaU: 1,
      stranicaR: 1,
      izbor: {},
      gotovo: {},
      dijalog: false,
      dijalogRed: null,
      odabraniPartner: null,
      snackbar: false,
      snackTekst: '',
      snackColor: 'green'
    }
  },
  computed: {
    godina () {
      return parseInt(this.$store.state.businessYear) || new Date().getFullYear()
    },
    uplatePrikaz () {
      return this.uplate.filter(r =>
        (this.konto === 'sve' || r.uplata.konto === this.konto) &&
        (this.filter === 'sve' || r.sigurnost === this.filter))
    },
    uplatePrikazStranica () {
      return this.uplatePrikaz.slice(0, this.stranicaU * KORAK)
    },
    racuniPrikaz () {
      return this.racuni.filter(r =>
        (this.konto === 'sve' || r.racun.konto === this.konto) &&
        (this.prikaziBezPrijedloga || r.sigurnost !== 'ceka_uplatu') &&
        (this.filter === 'sve' || (this.filter === 'visoka' && r.sigurnost === 'visoka') ||
          (this.filter === 'vise_moguce' && r.sigurnost === 'vise_moguce')))
    },
    racuniPrikazStranica () {
      return this.racuniPrikaz.slice(0, this.stranicaR * KORAK)
    },
    // Sve sigurne veze koje su sada na ekranu, iz oba popisa.
    sigurneVeze () {
      const veze = []
      this.uplatePrikaz.filter(r => r.sigurnost === 'visoka' && !this.gotovo['u' + r.uplata.id])
        .forEach(r => this.vezeUplate(r).forEach(v => veze.push(v)))
      this.racuniPrikaz.filter(r => r.sigurnost === 'visoka' && !this.gotovo['r' + r.racun.id])
        .forEach(r => this.vezeRacuna(r).forEach(v => veze.push(v)))
      return veze
    },
    sigurneBroj () {
      return this.uplatePrikaz.filter(r => r.sigurnost === 'visoka' && !this.gotovo['u' + r.uplata.id]).length +
        this.racuniPrikaz.filter(r => r.sigurnost === 'visoka' && !this.gotovo['r' + r.racun.id]).length
    },
    // Samo partneri s ispravnim OIB-om - bez njega se uplata ne moze povezati.
    partnerStavke () {
      const lista = this.$store.state.partnerStore || []
      const vidjeni = {}
      const rez = []
      lista.forEach(p => {
        const oib = String(p.partnerVATID || '').trim()
        if (!/^\d{11}$/.test(oib) || vidjeni[oib]) { return }
        vidjeni[oib] = true
        rez.push({partnerVATID: oib, partnerName: p.partnerName, tekst: (p.partnerName || '') + ' · ' + oib})
      })
      // Prijedlozi iz opisa mogu biti partneri kojih nema u listi firme.
      const r = this.dijalogRed
      if (r && r.partnerPrijedlog) {
        const kand = r.partnerPrijedlog.kandidati.length ? r.partnerPrijedlog.kandidati : [r.partnerPrijedlog]
        kand.forEach(k => {
          if (k.partnerVATID && !vidjeni[k.partnerVATID]) {
            vidjeni[k.partnerVATID] = true
            rez.unshift({partnerVATID: k.partnerVATID, partnerName: k.partnerName,
              tekst: (k.partnerName || '') + ' · ' + k.partnerVATID})
          }
        })
      }
      return rez
    }
  },
  watch: {
    konto () { this.vratiStranice() },
    filter () { this.vratiStranice() },
    prikaziBezPrijedloga () { this.vratiStranice() }
  },
  mounted () {
    this.ucitaj()
  },
  beforeDestroy () {
    if (this.odgoda) { clearTimeout(this.odgoda) }
  },
  methods: {
    novac (v) {
      return n2(v).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    datum (d) {
      return d ? dateFormat(d) : ''
    },
    vratiStranice () {
      this.stranicaU = 1
      this.stranicaR = 1
    },
    oznakaUplate (u) {
      if (u.BookName === 'BS') { return 'izv. ' + (u.BookID || '') }
      return String(u.BookName || '').replace(/_.*$/, '') + ' ' + (u.BookID || '')
    },
    oznakaRacuna (r) {
      return String(r.BookName || '').replace(/_.*$/, '') + ' ' + (r.brojRacuna || r.BookID || '')
    },
    izvorPartnera (izvor) {
      return {iban: 'IBAN-u', oib: 'OIB-u iz opisa', broj_racuna: 'broju računa iz opisa', naziv: 'nazivu iz opisa'}[izvor] || izvor
    },
    brojZaFilter (f) {
      const b = this.brojevi.uplate
      if (f === 'sve') { return b.ukupno }
      if (f === 'visoka') { return b.visoka }
      if (f === 'vise_moguce') { return b.viseMoguce }
      if (f === 'ceka_racun') { return b.cekaRacun }
      return b.nemaPartnera
    },
    javi (tekst, boja) {
      this.snackTekst = tekst
      this.snackColor = boja || 'green'
      this.snackbar = true
    },

    async ucitaj () {
      if (!this.$store.state.companyid) {
        this.greska = 'Nije odabrana firma.'
        return
      }
      this.ucitavam = true
      this.greska = ''
      try {
        const {data} = await MainLedgerZatvaranjeService.zaPovezati({
          CompanyId: this.$store.state.companyid,
          BusinessYear: this.godina,
          q: this.trazi ? this.trazi : undefined
        })
        this.uplate = data.uplate || []
        this.racuni = data.racuni || []
        this.brojevi = data.brojevi
        this.gotovo = {}
        this.izbor = {}
        this.vratiStranice()
        this.ucitano = true
      } catch (error) {
        this.greska = 'Greška kod čitanja popisa za povezati.'
      }
      this.ucitavam = false
    },
    traziOdgodjeno () {
      if (this.odgoda) { clearTimeout(this.odgoda) }
      this.odgoda = setTimeout(() => { this.ucitaj() }, 450)
    },

    // --- odabir racuna kad ih ima vise
    izborId (r) {
      const k = 'u' + r.uplata.id
      return this.izbor[k] !== undefined ? this.izbor[k] : r.racuni[0].id
    },
    postaviIzbor (r, id) {
      this.$set(this.izbor, 'u' + r.uplata.id, parseInt(id))
    },

    // --- veze za jedan redak
    vezeUplate (r) {
      const u = r.uplata
      if (r.razlog === 'zbroj_racuna') {
        return r.racuni.map(x => ({racunId: x.id, uplataId: u.id, iznos: n2(x.otvoreno)}))
      }
      const racun = r.racuni.length === 1 && r.kandidati.length <= 1
        ? r.racuni[0]
        : (r.kandidati.find(x => x.id === this.izborId(r)) || r.racuni[0])
      return [{racunId: racun.id, uplataId: u.id, iznos: n2(Math.min(racun.otvoreno, u.otvoreno))}]
    },
    vezeRacuna (r) {
      const racun = r.racun
      if (r.razlog === 'zbroj_uplata') {
        return r.uplate.map(u => ({racunId: racun.id, uplataId: u.id, iznos: n2(u.otvoreno)}))
      }
      const u = r.uplate[0]
      return [{racunId: racun.id, uplataId: u.id, iznos: n2(Math.min(racun.otvoreno, u.otvoreno))}]
    },

    async posalji (veze, izvor, napomena) {
      const korisnik = this.$store.state.user || {}
      const {data} = await MainLedgerZatvaranjeService.povezi({
        CompanyId: this.$store.state.companyid,
        BusinessYear: this.godina,
        izvor: izvor,
        UserId: korisnik.id || null,
        email: korisnik.email || null,
        napomena: napomena,
        veze: veze
      })
      return data
    },

    // Ishod jednog povezivanja: poruka, a redak se oznacava tek ako je veza upisana.
    async izvrsi (kljuc, veze, izvor, napomena) {
      this.povezujem = true
      try {
        const data = await this.posalji(veze, izvor, napomena)
        const odbijeno = data.odbijene || []
        if (data.upisano > 0) {
          this.$set(this.gotovo, kljuc, true)
          this.javi('Povezano.', 'green')
        }
        if (odbijeno.length > 0) {
          this.javi('Odbijeno: ' + odbijeno[0].razlog, 'red')
        }
        await this.ucitaj()
      } catch (error) {
        this.javi('Greška kod povezivanja.', 'red')
      }
      this.povezujem = false
    },
    poveziRedakUplate (r) {
      const izvor = r.sigurnost === 'visoka' ? 'auto' : 'rucno'
      this.izvrsi('u' + r.uplata.id, this.vezeUplate(r), izvor, 'Za povezati: ' + r.razlogTekst)
    },
    poveziRedakRacuna (r) {
      const izvor = r.sigurnost === 'visoka' ? 'auto' : 'rucno'
      this.izvrsi('r' + r.racun.id, this.vezeRacuna(r), izvor, 'Za povezati: ' + r.razlogTekst)
    },

    // Sve sigurne - jedan zahtjev, a server svaku vezu provjerava zasebno.
    async poveziSigurne () {
      const veze = this.sigurneVeze
      if (veze.length === 0) { return }
      const ukupno = n2(veze.reduce((a, v) => a + v.iznos, 0))
      if (!confirm('Povezati ' + this.sigurneBroj + ' sigurnih prijedloga (ukupno ' + this.novac(ukupno) + ')?')) { return }
      this.povezujem = true
      try {
        const data = await this.posalji(veze, 'auto', 'Za povezati: sigurni prijedlozi')
        const odbijeno = (data.odbijene || []).length
        this.javi('Povezano ' + data.upisano + ' veza' + (odbijeno ? ', odbijeno ' + odbijeno + ': ' + data.odbijene[0].razlog : '.'),
          odbijeno ? 'orange' : 'green')
        await this.ucitaj()
      } catch (error) {
        this.javi('Greška kod povezivanja.', 'red')
      }
      this.povezujem = false
    },

    // --- rucno: postojeci ekran zatvaranja stavaka
    otvoriStari (dokument) {
      const query = {zatvaranje: dokument && dokument.konto ? dokument.konto : '1200', godina: this.godina}
      if (dokument && dokument.partnerVATID) { query.partner = dokument.partnerVATID }
      this.$router.push({path: '/crm/mainledger/analysis', query: query}).catch(() => {})
    },

    // --- partner
    otvoriDijalog (r) {
      this.dijalogRed = r
      this.odabraniPartner = r.partnerPrijedlog ? r.partnerPrijedlog.partnerVATID : null
      this.dijalog = true
    },
    async potvrdiDijalog () {
      const stavka = this.partnerStavke.find(p => p.partnerVATID === this.odabraniPartner)
      if (!stavka) { return }
      await this.dodijeli(this.dijalogRed, stavka)
      this.dijalog = false
    },
    async dodijeli (r, partner) {
      this.povezujem = true
      try {
        await MainLedgerZatvaranjeService.dodijeliPartnera({
          CompanyId: this.$store.state.companyid,
          uplataId: r.uplata.id,
          partnerVATID: partner.partnerVATID,
          partnerName: partner.partnerName
        })
        this.javi('Partner dodijeljen.', 'green')
        await this.ucitaj()
      } catch (error) {
        const poruka = error && error.response && error.response.data && error.response.data.error
        this.javi(poruka || 'Greška kod dodjele partnera.', 'red')
      }
      this.povezujem = false
    }
  }
}
</script>

<style scoped>
.zp { font-family: Roboto, -apple-system, sans-serif; font-size: 15px; color: rgba(0, 0, 0, .87); max-width: 1280px; }

.zp-traka { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; background: #1976d2; color: #fff;
  border-radius: 4px; padding: 10px 14px; margin-bottom: 10px; }
.zp-naslov { font-size: 20px; font-weight: 700; line-height: 1.2; }
.zp-pod { font-size: 13px; opacity: .9; margin-top: 2px; }

.zp-b { font-family: inherit; font-size: 14px; font-weight: 500; border-radius: 4px; padding: 7px 14px;
  cursor: pointer; border: 1px solid transparent; white-space: nowrap; }
.zp-b[disabled] { opacity: .55; cursor: not-allowed; }
.zp-b-bijeli { background: #fff; color: #1976d2; }
.zp-b-stari { background: transparent; color: #fff; border-color: rgba(255, 255, 255, .6); }
.zp-b-zeleni { background: #43a047; color: #fff; }
.zp-b-obrub { background: #fff; color: #1976d2; border-color: #1976d2; }
.zp-b-sivi { background: #fff; color: rgba(0, 0, 0, .6); border-color: rgba(0, 0, 0, .12); }

.zp-greska { margin: 8px 0; padding: 8px 12px; border: 1px solid #e0b4a8; border-radius: 4px;
  background: #fdecea; color: #c62828; }

.zp-brojke { display: flex; flex-wrap: wrap; gap: 26px; background: #fff; border: 1px solid rgba(0, 0, 0, .12);
  border-radius: 4px; padding: 10px 16px; margin-bottom: 10px; }
.zp-brojke span { display: block; font-size: 12px; color: rgba(0, 0, 0, .6); line-height: 1.2; }
.zp-brojke b { font-size: 19px; font-variant-numeric: tabular-nums; }
.zp-brojke .zp-ok b { color: #2e7d32; }
.zp-brojke .zp-lose b { color: #c62828; }

.zp-alati { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; margin-bottom: 10px; }
.zp-trazi { max-width: 340px; }
.zp-seg { display: inline-flex; border: 1px solid rgba(0, 0, 0, .12); border-radius: 4px; overflow: hidden; background: #fff; }
.zp-seg button { border: 0; background: #fff; padding: 7px 12px; font: inherit; font-size: 13px; cursor: pointer;
  color: rgba(0, 0, 0, .6); border-right: 1px solid rgba(0, 0, 0, .12); }
.zp-seg button:last-child { border-right: 0; }
.zp-seg button.aktivan { background: #eef4fb; color: #1565c0; font-weight: 700; }
.zp-seg button i { font-style: normal; font-size: 12px; opacity: .75; padding-left: 3px; }
.zp-kvacica { font-size: 13px; color: rgba(0, 0, 0, .6); cursor: pointer; }

.zp-kartica { background: #fff; border: 1px solid rgba(0, 0, 0, .12); border-radius: 4px; margin-bottom: 10px; overflow: hidden; }
.zp-glava { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; background: #eef4fb;
  border-bottom: 2px solid #1976d2; padding: 8px 14px; }
.zp-glava h2 { margin: 0; font-size: 17px; color: #1565c0; font-weight: 700; }
.zp-glava small { color: rgba(0, 0, 0, .6); }
.zp-razmak { flex: 1; }
.zp-podnaslov { padding: 8px 14px; background: #eef4fb; border-top: 2px solid #1976d2; border-bottom: 1px solid rgba(0, 0, 0, .12);
  font-size: 16px; font-weight: 700; color: #1565c0; }
.zp-podnaslov span { font-size: 13px; font-weight: 400; color: rgba(0, 0, 0, .6); }
.zp-prazno { padding: 18px 14px; color: rgba(0, 0, 0, .6); font-size: 14px; }
.zp-jos { padding: 10px 14px; text-align: center; border-top: 1px solid rgba(0, 0, 0, .12); }

.zp-red { display: grid; grid-template-columns: 1.5fr 1.7fr 190px; gap: 12px; align-items: center;
  padding: 10px 14px; border-top: 1px solid rgba(0, 0, 0, .12); }
.zp-glava + .zp-red, .zp-podnaslov + .zp-red { border-top: 0; }
.zp-red.gotovo { background: #e8f5e9; opacity: .65; }
.zp-partner { font-weight: 500; }
.zp-partner small { font-weight: 400; color: rgba(0, 0, 0, .6); font-size: 12px; padding-left: 6px; }
.zp-opis { font-size: 13px; color: rgba(0, 0, 0, .6); word-break: break-word; }
.zp-datum { font-size: 12px; color: rgba(0, 0, 0, .6); }
.zp-datum b { color: rgba(0, 0, 0, .87); font-variant-numeric: tabular-nums; }
.zp-prijedlog { font-size: 14px; }
.zp-prijedlog small { display: block; color: rgba(0, 0, 0, .6); font-size: 12px; margin-top: 2px; }
.zp-radnja { display: flex; gap: 6px; justify-content: flex-end; flex-wrap: wrap; }
.zp-gotovo { color: #2e7d32; font-weight: 500; }

.zp-oznaka { display: inline-block; font-size: 12px; border-radius: 10px; padding: 1px 9px; margin-right: 6px; }
.zp-oznaka.visoka { background: #e8f5e9; color: #2e7d32; }
.zp-oznaka.zuta { background: #fff4e0; color: #b26a00; }
.zp-oznaka.crvena { background: #fdecea; color: #c62828; }

.zp-zeton { display: inline-block; border: 1px solid #1976d2; color: #1976d2; border-radius: 16px;
  padding: 2px 10px; font-size: 12px; margin: 2px 4px 2px 0; }
.zp-klik { cursor: pointer; }
.zp-izbor { max-width: 100%; margin-top: 4px; padding: 4px 6px; font: inherit; font-size: 13px;
  border: 1px solid rgba(0, 0, 0, .2); border-radius: 4px; background: #fff; display: block; }

.zp-dijalog-naslov { background: #eef4fb; border-bottom: 2px solid #1976d2; color: #1565c0; font-size: 17px !important; font-weight: 700; }

@media (max-width: 860px) {
  .zp-red { grid-template-columns: 1fr; }
  .zp-radnja { justify-content: flex-start; }
}
</style>
